<template>
    <div name="list" class="list">
        <count-info 
            :count="vocPage.allCount"
        />
        <div style="width: 100%;text-align: right; margin-bottom: 16px; margin-top: 32px;"> 
            <sort-button 
                @change="change"
            />
        </div>
        <card 
            v-for="(info, index) in vocPage.vocs"
            :key="`card_${index}`"
            :number="info.order"
            :info="info"
            :background="index % 2 === 0 ? 'background: var(--Gray-00, #FFF);': 'background: var(--Blue-04_Light-blue, #E5F0FC);'"
            style="margin-bottom: 8px"
            :isLike="isUserLike(info.id)"
            @onLike="onLike(info.id)"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex';
import CountInfo from '@/components/molecules/m_uncomfortable/CountInfo';
import Card from '@/components/molecules/m_uncomfortable/Card'
import SortButton from '@/components/molecules/m_uncomfortable/SortButton';
import Cookie from '@/utilities/cookie';


export default {
  components: { CountInfo, Card, SortButton },
    name: 'list',
    computed: mapState(['vocPage', 'vocLoginKakaoToken']),
    methods: {
        change: function(type)
        {
            this.$emit('change', type)
        },
        isUserLike: function(index)
        {
            if(this.vocLoginKakaoToken === null || this.vocLoginKakaoToken === undefined || this.vocLoginKakaoToken === '')
            {
                return false;
            }
            else
            {
                return this.isSavedValue(index);
                
            }
        },
        onLike: function(index)
        {
            if(this.vocLoginKakaoToken === null || this.vocLoginKakaoToken === undefined || this.vocLoginKakaoToken === '')
            {
                // login 필요
                this.$emit('login')
            }
            else
            {
                if(this.isSavedValue(index))
                {
                    return true;
                }
                else
                {
                    this.$emit('like', index)
                }
            }
        },
        isSavedValue: function(index)
        {
            // 검증 필요
            let likedata = JSON.parse(Cookie.getLocalStorageWithExpire("voclike"));

            if(likedata === null)
            {
                // like 검증하여 
                return false;
            }

            let ids = Cookie.getValueByKey(likedata, this.vocLoginKakaoToken);

            if(ids === null)
            {
                return false;
            }

            if(ids.length === undefined)
            {
                if(ids === index)
                {
                    return true;
                }
                else 
                {
                    // like 검증하여 
                    return false;
                }
            }
            else
            {
                if(ids.indexOf(index) > -1)
                {
                    return true;
                }
                else
                {
                    // like 검증하여 
                    return false;
                }
            }
        }
    }
}
</script>

<style scoped>
    .list {
        width: 100%;
        background: #212529;   
        padding: 45px 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/m_uncomfortable/list.vue